package com.maximdvinov.i18n

import com.maximdvinov.models.LocalizedText

object AppStrings {
    val title = LocalizedText("Максим Двинов", "Maxim Dvinov")
    val role = LocalizedText("Android и KMP разработчик", "Android and KMP Developer")
    val intro = LocalizedText(
        "Android-разработчик с опытом коммерческой разработки приложений под разные задачи. Использую Kotlin, Java, Jetpack, MVVM, XML и Jetpack Compose.",
        "Android developer with commercial experience building apps for different business needs. I work with Kotlin, Java, Jetpack, MVVM, XML, and Jetpack Compose.",
    )
    val projects = LocalizedText("Проекты", "Projects")
    val selectedProjects = LocalizedText("Мои проекты", "My projects")
    val contacts = LocalizedText("Контакты", "Contacts")
    val technologies = LocalizedText("Технологии", "Technologies")
    val technologyLead = LocalizedText(
        "Для новых продуктов использую современный Kotlin-стек и выбираю инструменты под задачу, а не ради моды.",
        "For new products, I use a modern Kotlin stack and choose tools based on the problem, not trend value.",
    )
    val projectsLead = LocalizedText(
        "Подборка мобильных и кроссплатформенных приложений: личные проекты, дипломная работа и заказная разработка.",
        "A selection of mobile and cross-platform apps: personal projects, graduation work, and commissioned development.",
    )
    val backToHome = LocalizedText("На главную", "Back home")
    val aboutProject = LocalizedText("О проекте", "About the project")
    val myRole = LocalizedText("Роль в проекте", "Project role")
    val stack = LocalizedText("Стек", "Stack")
    val gallery = LocalizedText("Галерея", "Gallery")
    val quickFacts = LocalizedText("Кратко", "At a glance")
    val year = LocalizedText("Год", "Year")
    val platform = LocalizedText("Платформа", "Platform")
    val status = LocalizedText("Статус", "Status")
    val projectNotFound = LocalizedText("Проект не найден", "Project not found")
    val projectNotFoundHint = LocalizedText(
        "Проверьте ссылку или вернитесь на главную страницу.",
        "Check the link or return to the homepage.",
    )
    val heroKicker = LocalizedText("Kotlin Developer / Android / KMP", "Kotlin Developer / Android / KMP")
    val availability = LocalizedText("Открыт к продуктовым Android и KMP проектам", "Open to product Android and KMP projects")
    val contactLine = LocalizedText(
        "Android-разработка, Kotlin Multiplatform, Jetpack Compose и доведение приложений до публикации.",
        "Android development, Kotlin Multiplatform, Jetpack Compose, and taking apps through to release.",
    )
    val writeTelegram = LocalizedText("Написать в Telegram", "Message on Telegram")
    val openGithub = LocalizedText("Открыть GitHub", "Open GitHub")
    val openKwork = LocalizedText("Открыть Kwork", "Open Kwork")
    val email = LocalizedText("Email", "Email")
}
